import React, { ReactNode, useContext } from 'react';
import { Grid, Box, Container } from '@mui/material';
import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';
import NoData from '../../routes/NoData';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

interface AdminWrapperProps {
  children: ReactNode;
}

const AdminWrapper: React.FC<AdminWrapperProps> = ({ children }) => {
  const context = useContext<DataContextType | undefined>(DataContext);
  const { playerData } = context || {};

  if (!playerData) {
    return <NoData />;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ flexGrow: 1 }}>
        <TopBar />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9} md={10}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminWrapper;